import React, { FC } from "react";

import { useBoolean } from "~/hooks";

import { AnalysisPostCountType } from "~/domains";

import { ButtonWithIcon, LineAndAreaChart, ModalWrapper } from "~/ui";
import { Loading } from "~/ui";

type PropsType = {
  isLoading: boolean;
  title: string;
  postAnalysis?: AnalysisPostCountType[];
  onlyModalTitle?: boolean;
  className?: string;
};

export const AnalysisCumulativeOfPostGraph: FC<PropsType> = ({
  isLoading,
  title,
  postAnalysis,
  onlyModalTitle = false,
  className = "",
}: PropsType) => {
  const { isChecked, setTrue, setFalse } = useBoolean(false);

  return (
    <div className={`${className}`}>
      {!onlyModalTitle && (
        <p className="font-semibold text-primary-600 text-lg text-center">
          {title}
        </p>
      )}
      <div className="shadow mt-4 p-4 rounded-md flex justify-center text-center">
        {isLoading ? (
          <Loading />
        ) : (
          postAnalysis && (
            <>
              <LineAndAreaChart
                areaLabel="累計投稿数"
                lineLabel="平均累積投稿数"
                datasets={postAnalysis.map((item) => ({
                  name: item.name,
                  areaValue: item.postsTotalCount,
                  lineValue: item.postsAverageCount,
                }))}
              />
              <ButtonWithIcon
                srOnlyText="グラフを拡大する"
                icon={{
                  icon: "ioScanOutline",
                  color: "text-secondary-600",
                  size: "1.25rem",
                }}
                onClick={setTrue}
                className="flex justify-end"
              />
            </>
          )
        )}
      </div>
      {postAnalysis && isChecked && (
        <ModalWrapper
          onClose={setFalse}
          headerTitle={title}
          className={className}
        >
          <div className="mt-4 rounded-md">
            <LineAndAreaChart
              areaLabel="累計投稿数"
              lineLabel="平均累積投稿数"
              datasets={postAnalysis.map((item) => ({
                name: item.name,
                areaValue: item.postsTotalCount,
                lineValue: item.postsAverageCount,
              }))}
            />
          </div>
        </ModalWrapper>
      )}
    </div>
  );
};
